module.exports = __webpack_public_path__ + "static/media/minicode.ea0f4ba7.png";